const EARTH_RADIUS_M = 6371000
const MIN_CAMERA_RANGE_M = 1000
const MAX_CAMERA_RANGE_M = 20000
const TRACK_FRAME_MULTIPLIER = 1.8

const hasFiniteMapCenter = (lat, lng) => (
  lat !== null && lat !== undefined && lng !== null && lng !== undefined &&
  Number.isFinite(Number(lat)) && Number.isFinite(Number(lng))
)

const haversineMeters = (a, b) => {
  const radians = degrees => degrees * Math.PI / 180
  const lat1 = radians(a.lat)
  const lat2 = radians(b.lat)
  const dLat = lat2 - lat1
  const dLng = radians(b.lng - a.lng)
  const value = Math.sin(dLat / 2) ** 2 + Math.cos(lat1) * Math.cos(lat2) * Math.sin(dLng / 2) ** 2
  return 2 * EARTH_RADIUS_M * Math.asin(Math.sqrt(value))
}

const cameraRangeForTrack = points => {
  const valid = (points || [])
    .filter(point => hasFiniteMapCenter(point?.lat, point?.lng))
    .map(point => ({ lat: Number(point.lat), lng: Number(point.lng) }))
  if (valid.length < 2) return MIN_CAMERA_RANGE_M

  let minLat = valid[0].lat
  let maxLat = valid[0].lat
  let minLng = valid[0].lng
  let maxLng = valid[0].lng
  valid.forEach(point => {
    minLat = Math.min(minLat, point.lat)
    maxLat = Math.max(maxLat, point.lat)
    minLng = Math.min(minLng, point.lng)
    maxLng = Math.max(maxLng, point.lng)
  })
  const diagonal = haversineMeters(
    { lat: minLat, lng: minLng },
    { lat: maxLat, lng: maxLng },
  )
  return Math.min(MAX_CAMERA_RANGE_M, Math.max(MIN_CAMERA_RANGE_M, diagonal * TRACK_FRAME_MULTIPLIER))
}

module.exports = {
  cameraRangeForTrack,
  hasFiniteMapCenter,
}
